var map = {
	"./Icon - 24 - Jaw lower.svg": 3123,
	"./Icon - 24 - Jaw upper.svg": 3830,
	"./Icon - 32 - Back view.svg": 2599,
	"./Icon - 32 - Front view.svg": 2180,
	"./Icon - 32 - Left side view.svg": 9322,
	"./Icon - 32 - Occlusal view of the Lower Jaw.svg": 939,
	"./Icon - 32 - Occlusal view of the upper jaw.svg": 8312,
	"./Icon - 32 - right jaw view.svg": 6103,
	"./Icon - 36 - Attachment.svg": 236,
	"./Icon - 36 - Bite Ramps.svg": 6361,
	"./Icon - 36 - Bolton, Tonn, Pont Analyses.svg": 8168,
	"./Icon - 36 - Cephalometry.svg": 4030,
	"./Icon - 36 - Contacts.svg": 6322,
	"./Icon - 36 - Contour offset - Lower Jaw.svg": 7797,
	"./Icon - 36 - Contour offset - Upper Jaw.svg": 5763,
	"./Icon - 36 - Digits - Extrude.svg": 646,
	"./Icon - 36 - Digits - Size.svg": 3693,
	"./Icon - 36 - Elastic-Button.svg": 2925,
	"./Icon - 36 - Elastics.svg": 6318,
	"./Icon - 36 - Grid and ruler.svg": 8648,
	"./Icon - 36 - Grid.svg": 6390,
	"./Icon - 36 - Gum.svg": 2319,
	"./Icon - 36 - IPR.svg": 4460,
	"./Icon - 36 - Jaw displacement.svg": 9102,
	"./Icon - 36 - Marking.svg": 9825,
	"./Icon - 36 - Overlay.svg": 1504,
	"./Icon - 36 - Package Length---.svg": 3081,
	"./Icon - 36 - Package Width.svg": 2195,
	"./Icon - 36 - Patient photo.svg": 6428,
	"./Icon - 36 - Penetration.svg": 6699,
	"./Icon - 36 - Pontic.svg": 3492,
	"./Icon - 36 - Separation.svg": 262,
	"./Icon - 36 - Stickers Length-.svg": 8878,
	"./Icon - 36 - Stickers Width.svg": 363,
	"./Icon - 36 - Stickers.svg": 2074,
	"./Icon - 36 - Tooling.svg": 4621,
	"./Icon - 40 - Cutting.svg": 4942,
	"./Icons - 36 - 1.svg": 9822,
	"./Icons - 36 - Angulation M-D - bottom.svg": 5465,
	"./Icons - 36 - Angulation M-D - top.svg": 7571,
	"./Icons - 36 - Free gizmo.svg": 9612,
	"./Icons - 36 - Lifetime.svg": 4722,
	"./Icons - 36 - Lock tooth.svg": 3749,
	"./Icons - 36 - No tool.svg": 4283,
	"./Icons - 36 - P.svg": 2532,
	"./Icons - 36 - Remove tooth.svg": 3522,
	"./Icons - 36 - Rotation M-D.svg": 2812,
	"./Icons - 36 - Torque B-L - bottom.svg": 563,
	"./Icons - 36 - Torque B-L - top.svg": 3351,
	"./Icons - 36 - Translation B-L.svg": 1438,
	"./Icons - 36 - Translation E-I.svg": 8736,
	"./Icons - 36 - Translation M-D.svg": 3700,
	"./Sculpting - Extrude.svg": 4192,
	"./Sculpting - Intrude.svg": 1841,
	"./Sculpting - Patcher.svg": 3810,
	"./Sculpting - Repair.svg": 356,
	"./Sculpting - Smoth.svg": 2675,
	"./arrow.svg": 5412,
	"./close.svg": 2704,
	"./demo.svg": 7130,
	"./hearer - hover for icon.svg": 8857,
	"./icon - 36 -  one.svg": 501,
	"./icon - 36 - Align Jaw in viewport.svg": 4087,
	"./icon - 36 - Articulator.svg": 9736,
	"./icon - 36 - Auto Articulation.svg": 5397,
	"./icon - 36 - tooth contour -.svg": 1323,
	"./icon-1.svg": 6980,
	"./icon-10.svg": 9419,
	"./icon-11.svg": 5869,
	"./icon-12.svg": 5604,
	"./icon-13.svg": 8881,
	"./icon-14.svg": 5336,
	"./icon-15.svg": 4618,
	"./icon-16.svg": 3921,
	"./icon-17.svg": 1859,
	"./icon-18.svg": 1921,
	"./icon-19.svg": 3062,
	"./icon-2.svg": 5134,
	"./icon-20.svg": 4973,
	"./icon-3.svg": 3901,
	"./icon-4.svg": 2353,
	"./icon-5.svg": 2231,
	"./icon-6.svg": 2435,
	"./icon-7.svg": 8576,
	"./icon-8.svg": 8504,
	"./icon-9.svg": 5573,
	"./icon-attachments-white.svg": 4550,
	"./icon-bite-ramps-white.svg": 7483,
	"./icon-elastics-white.svg": 3906,
	"./icon-grid.svg": 8374,
	"./icon-jaw-bottom-white.svg": 3806,
	"./icon-jaw-displacement.svg": 1738,
	"./icon-jaw-top-white.svg": 5867,
	"./icon-pontiki-hide-white.svg": 3878,
	"./icon-redo.svg": 1485,
	"./icon-separation-white.svg": 390,
	"./icon-undo.svg": 8531,
	"./logo-vision.svg": 8161,
	"./play.svg": 2222,
	"./share.svg": 8330
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2289;